import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  makeStyles,
  Step,
  StepButton,
  StepContent,
  StepLabel,
  Stepper,
  Typography,
} from '@material-ui/core';
import {ExpandMore as ExpandMoreIcon} from '@material-ui/icons';
import PropTypes from 'prop-types';
import React, {useState} from 'react';
import {getStepContent, getSteps} from '../stepper-steps/getSteps';
import {accordionA11yProps} from '../utils/accordionA11yProps';

const useStyles = makeStyles(({palette}) => ({
  stepper: {
    width: '100%',
  },
  heading: {
    fontSize: '1.7em',
  },
  stepperHeader: {
    color: palette.meterTypeTextColor,
    backgroundColor: palette.meterTypeColor,
    '& svg': {
      color: palette.meterTypeTextColor,
    },
  },
  stepButton: {
    '& .MuiStepIcon-active': {
      opacity: 1,
      color: palette.meterTypeColor,
    },
    '& .MuiStepIcon-completed': {
      color: palette.meterTypeColor,
      opacity: 0.6,
    },
  },
  stepIcon: {
    color: palette.meterTypeColor,
    opacity: 0.6,
  },
  stepIconText: {
    display: 'none',
  },
}));

export const ProjectPlanStepper = ({meter, setMeter, user, sponsor}) => {
  const classes = useStyles(meter);
  const [activeStep, setActiveStep] = useState(-1);
  const [expanded, setExpanded] = useState(true);

  const [
    disableDataCollectionBtn,
    setDisableDataCollectionBtn,
  ] = React.useState(false);

  React.useEffect(() => {
    if (meter.currentStep) {
      setActiveStep(meter.currentStep);
    } else {
      setActiveStep(0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [meter._id]);

  const isMeterOwner = meter.user === user._id ? true : false;

  const steps = getSteps();

  const handleStep = (step) => () => {
    setActiveStep(step);
  };

  const a11y = accordionA11yProps({
    id: 'project-plan',
    expanded,
    label: expanded ? 'collapse project plan' : 'expand project plan',
  });

  const toggleExpansionPanel = () => {
    setExpanded(!expanded);
  };

  return (
    <div className={classes.stepper}>
      <Accordion expanded={expanded} onChange={toggleExpansionPanel}>
        <AccordionSummary
          className={classes.stepperHeader}
          expandIcon={<ExpandMoreIcon />}
          {...a11y.summaryProps}
        >
          <Typography className={classes.heading}>Project Plan</Typography>
        </AccordionSummary>
        <AccordionDetails {...a11y.detailsProps}>
          <Typography component="div" classes={{root: classes.stepper}}>
            <Stepper nonLinear activeStep={activeStep} orientation="vertical">
              {steps.map((label, index) => {
                const stepProps = {};
                if (index < activeStep) {
                  stepProps.completed = true;
                }

                return (
                  <Step key={label} {...stepProps}>
                    <StepButton
                      classes={{
                        root: classes.stepButton,
                      }}
                      onClick={handleStep(index)}
                    >
                      <StepLabel
                        StepIconProps={{
                          classes: {
                            root: classes.stepIcon,
                            text: classes.stepIconText,
                          },
                        }}
                      >
                        {label}
                      </StepLabel>
                    </StepButton>
                    <StepContent>
                      <Typography component="div">
                        {getStepContent(
                          activeStep,
                          {
                            meter,
                            setMeter,
                            isMeterOwner,
                            disableDataCollectionBtn,
                            setActiveStep,
                            setDisableDataCollectionBtn,
                            sponsor,
                          },
                          user,
                        )}
                      </Typography>
                    </StepContent>
                  </Step>
                );
              })}
            </Stepper>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

ProjectPlanStepper.propTypes = {
  meter: PropTypes.object.isRequired,
  setMeter: PropTypes.func,
  user: PropTypes.object.isRequired,
  sponsor: PropTypes.object,
};
